import React from 'react';
import { UserCheckIcon, HomeIcon, HandshakeIcon, CheckCircle2Icon } from 'lucide-react';
export function HowItWorks() {
  const steps = [{
    icon: UserCheckIcon,
    title: 'Regístrate gratis',
    description: 'Crea tu cuenta en nuestra red privada y recibe 3 créditos mensuales para solicitar canjes'
  }, {
    icon: HomeIcon,
    title: 'Publica propiedades',
    description: 'Publica todas tus propiedades gratis. Marca "Abierto a Canje" y recibe coincidencias automáticas'
  }, {
    icon: HandshakeIcon,
    title: 'Solicita canjes',
    description: 'Usa 1 crédito por solicitud. Si te rechazan, recuperas el crédito automáticamente'
  }, {
    icon: CheckCircle2Icon,
    title: 'Cierra el canje',
    description: 'Define split, vigencia y exclusividad. Registra el cierre y construye tu reputación'
  }];
  return <section id="como-funciona" className="py-12 sm:py-20 px-4 sm:px-6 lg:px-8 bg-gray-50" data-id="element-252">
      <div className="max-w-6xl mx-auto" data-id="element-253">
        <div className="text-center mb-12 sm:mb-16" data-id="element-254">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 mb-3 sm:mb-4" data-id="element-255">
            Cómo funciona
          </h2>
          <p className="text-lg sm:text-xl text-gray-600 mb-4" data-id="element-256">
            Cuatro pasos simples para transformar tu forma de hacer canje
          </p>
          <p className="max-w-2xl mx-auto text-gray-500 text-base sm:text-lg" data-id="element-257">
            Canjee es una red privada. Publica propiedades gratis y usa créditos
            solo para solicitar canjes. Si te rechazan, recuperas tu crédito
            automáticamente.
          </p>
        </div>
        <div className="flex sm:grid sm:grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8 overflow-x-auto snap-x snap-mandatory sm:overflow-x-visible pb-4 sm:pb-0 -mx-4 px-4 sm:mx-0 sm:px-0" data-id="element-258">
          {steps.map((step, index) => <div key={index} className="relative min-w-[75vw] sm:min-w-0 snap-center pt-4" data-id="element-259">
              <div className="bg-white rounded-2xl p-6 border border-gray-200 hover:border-indigo-900 hover:shadow-lg transition-all h-full" data-id="element-260">
                <div className="flex items-center justify-center w-14 h-14 bg-indigo-100 rounded-xl mb-4" data-id="element-261">
                  <step.icon className="w-7 h-7 text-indigo-900" data-id="element-262" />
                </div>
                <div className="absolute top-0 left-3 w-8 h-8 bg-indigo-900 text-white rounded-full flex items-center justify-center font-bold text-sm" data-id="element-263">
                  {index + 1}
                </div>
                <h3 className="text-base sm:text-lg font-bold text-gray-900 mb-2" data-id="element-264">
                  {step.title}
                </h3>
                <p className="text-gray-600 text-sm" data-id="element-265">{step.description}</p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}